import HeaderComponent from './HeaderComponent';

export default class HeaderInvertedComponent extends HeaderComponent {
  scrollUpFunction() {
    this.dom.mainHeaderLogoContainer.classList.add(this.CLASSES.hideLogo);
    this.applyClassesHeaderCRO('close', this.CLASSES.menuWithBackground);
    if (this.headerIsCRO) {
      if (this.dom.searchIcon) {
        this.dom.searchIcon.classList.remove(this.CLASSES.showHeaderActions);
      }
      if (this.dom.searchWrapperCro) {
        this.dom.searchWrapperCro.classList.remove(
          this.CLASSES.searchWrapperCroScrolled
        );
      }
    }
    if (this.dom.benefitBar) {
      this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.show);
    }
  }

  scrollDownFunction() {
    if (
      this.dom.mainHeader.classList.contains(
        this.CLASSES.hideBenefitBarOnScrollEnabled
      )
    ) {
      if (
        !this.dom.menuContainer.classList.contains(this.CLASSES.openedClass) &&
        this.dom.benefitBar
      ) {
        this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.hideByScroll);
      }
    }
    this.dom.mainHeaderLogoContainer.classList.remove(this.CLASSES.hideLogo);
    this.applyClassesHeaderCRO('open', this.CLASSES.menuWithBackground);
    if (this.headerIsCRO) {
      if (this.dom.searchIcon) {
        this.dom.searchIcon.classList.add(this.CLASSES.showHeaderActions);
      }
      if (this.dom.searchWrapperCro) {
        this.dom.searchWrapperCro.classList.add(
          this.CLASSES.searchWrapperCroScrolled
        );
      }
    }
  }
}
